<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('ribbons/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('production.ribbon_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameRibbonSelected"
            :visible.sync="modals.read"
            width="50%"
            top="2%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td
                        :style="
                          'background-color: ' +
                          rowData.color_code +
                          ';color:' +
                          rowData.color_text
                        "
                      >
                        <h6>
                          <strong>{{ $t('common_words.color') }}:</strong>
                        </h6>
                        {{ rowData.color_code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ rowData.color_name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(business, index) in rowData.business_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="rowData.business_names.length == 0"
                          >{{
                            $t('common_words.no_associated_companies')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.calendars_associated_s') }}:
                          </strong>
                        </h6>
                        <span
                          v-for="(cal, index) in rowData.calendar_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ cal }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="rowData.calendar_names.length == 0"
                          >{{
                            $t('common_words.no_associated_calendars_multiple')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-white">
                  <small
                    >{{ $t('common_words.created_on  ') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              filterable
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :cell-style="handlecellstyle"
              :default-sort="{ prop: 'id', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="65"
                :resizable="false"
                :align="'center'"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="100"
                label="Color"
                prop="props.color"
                :sortable="true"
                :resizable="false"
                :align="'center'"
              >
                <template slot-scope="props">
                  <div class="text">
                    <span v-bind:style="'color:' + props.row.color_text">{{
                      props.row.color_code
                    }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="150"
                :label="$t('common_words.associated_companies')"
                prop="business_names"
                :sortable="true"
                :resizable="false"
                align="center"
              >
                <template slot-scope="props">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="props.row.business_names.length > 0"
                    :hidden="
                      props.row.business_names.length == 1 ? true : false
                    "
                    :value="200"
                    :max="props.row.business_names.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ props.row.business_names[0] }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                min-width="150"
                :label="$t('common_words.calendars_associated_s')"
                prop="calendar_names"
                :sortable="true"
                :resizable="false"
                align="center"
              >
                <template slot-scope="props">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="props.row.calendar_names.length > 0"
                    :hidden="
                      props.row.calendar_names.length == 1 ? true : false
                    "
                    :value="200"
                    :max="props.row.calendar_names.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ props.row.calendar_names[0] }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :label="$t('common_words.operations')"
                fixed="right"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import SweetAlert from 'src/class/Alerts';
import configTable from './ribbonTable';
import { Axios } from 'src/class/Axios.js';
import Fuse from 'fuse.js';
import moment from 'moment';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().Search,
    nameRibbonSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },
  data() {
    return {
      ribbonForm: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = '/ribbons/edit';
      this.ribbonForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.ribbonForm));
      this.$router.push({
        path: 'ribbons/edit',
      });
    },

    handleDelete(index, row) {
      this.ribbonForm = row;
      SweetAlert.delete(
        i18n.t('production.the_ribbon') + this.ribbonForm.color_name
      ).then((result) => {
        if (result.value) this.deleteRibbon();
      });
    },

    handlecellstyle({ row, columnIndex }) {
      if (row.color_code && columnIndex == 2) {
        return 'background-color: ' + row.color_code;
      }
    },

    deleteRibbon() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.ribbonForm.route = 'ribbons';
        Axios.destroyMaster(this.ribbonForm)
          .then((response) => this.modifyTable(2, this.ribbonForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'ribbons/pdf';
      data.name_file = `${i18n.t('production.ribbon')}.pdf`;

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = {};
      data.route = 'ribbons/excel';
      data.name_file = `${i18n.t('production.ribbon')}.xlsx`;

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('ribbons')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns
              .map((prop) => {
                return prop.prop;
              })
              .concat(['color', 'business_names', 'calendar_names']),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('ribbons');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('ribbons');
  },
};
</script>
<style></style>
